import 'core-js/stable';

import { App } from './App';
import { envIsProduction, envIsTest } from 'dg-web-shared/lib/Environment';
import * as Sentry from '@sentry/react';
import { tabFlowId } from 'dg-web-shared/lib/FlowId';
import { withBackendRequestId } from 'dg-web-shared/lib/SentryRequestId';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { initUpdater } from 'dg-web-shared/common/utils/UpdateUtils.ts';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom';

export function initSentry(dsn: string) {
    Sentry.init({
        dsn: dsn,
        attachStacktrace: true,
        initialScope: { tags: { service: 'parkingabo-app' } },
        beforeBreadcrumb: withBackendRequestId,
        integrations: [
            Sentry.browserSessionIntegration({ lifecycle: 'page' }),
            Sentry.reactRouterBrowserTracingIntegration({
                useEffect,
                createRoutesFromChildren,
                matchRoutes,
                useLocation,
                useNavigationType,
            }),
            Sentry.captureConsoleIntegration({
                levels: ['error'],
            }),
        ],
    });
    // sets the flow_id tag before the first request
    tabFlowId();
}

if (envIsProduction()) {
    initSentry(
        'https://fd1c9c8235734ac4a5d62e134ac69680@o28142.ingest.sentry.io/5856623',
    );
} else if (envIsTest()) {
    initSentry(
        'https://0dba0e9032174065b08c9d8737160701@o28142.ingest.sentry.io/5856621',
    );
}

initUpdater();

const container = document.getElementById('app-container');
const root = createRoot(container!);
root.render(<App />);
